import { Component, FormCreationData } from '../../../../../stateManager/store/formCreation_v2/types'

export const getParentModal = (id: string, components: Component): FormCreationData | null => {
  const component = components[id]
  if(!component) {
    return null
  }

  const parentId = component.parentId || ""
  const parentComponent = components[parentId]
  if(!parentComponent) {
    return null
  }

  if(parentComponent.type === 'CustomModal') {
    return parentComponent
  }

  return getParentModal(parentComponent.id, components)
}
